import * as yup from 'yup';
import {
	environments,
	thirdStep,
	secondStep,
	fourthStep,
	editCreateEnvironment,
} from '../core/messages/en';
import {
	EH_ENV_NAME_VALIDATION_PATTERN,
	ENVIRONMENT_NAME_VALIDATION_PATTERN,
} from '../utils/constants';
import { t } from '@transifex/native';
import { TenantType } from '../types';

const {
	requiredEnvironmentName,
	invalidEnvironmentName,
	invalidEhEnvironmentName,
	requiredEhEnv,
} = environments;
const { maxCharacters: envMaxCharacters } = thirdStep;
const {
	repoRequired,
	orgRequired,
	projectNameRequired,
	repositoryNameValidationMessage,
	repoBranchRequired,
} = secondStep;
const { requriedCmEnv } = fourthStep;
const {
	needToContinue,
	tenantTypeValidation3,
	tenantTypeValidation4,
	requiredAccount,
} = editCreateEnvironment;

const { Production, NonProduction } = TenantType;

const normalizeTenantType = (value: unknown): TenantType | undefined => {
	if (value === null || value === undefined) return undefined;

	const parsed = typeof value === 'string' ? Number(value) : value;
	if (parsed === Production || parsed === NonProduction) return parsed;
	return undefined;
};

const notRequired = () => yup.string().notRequired();

const validateRepository = (isRequired: boolean) =>
	isRequired
		? yup
				.string()
				.required(repoRequired)
				.matches(
					/^[A-Za-z0-9_.-]{1,100}$/,
					repositoryNameValidationMessage,
				)
		: notRequired();

const validate = (isRequired: boolean, msg: string) =>
	isRequired ? yup.string().required(msg) : notRequired();

const validateEnvironmentName = (isCm: boolean) =>
	yup
		.string()
		.required(isCm ? requiredEnvironmentName : requiredEhEnv)
		.max(100, envMaxCharacters)
		.matches(
			new RegExp(
				isCm
					? ENVIRONMENT_NAME_VALIDATION_PATTERN
					: EH_ENV_NAME_VALIDATION_PATTERN,
			),
			isCm ? invalidEnvironmentName : invalidEhEnvironmentName,
		);

export const createEditEnvValidationSchema = ({
	isAdoProvider,
	allEnvironmentsLimitation,
	isCreate,
	isCm,
}: {
	isAdoProvider: boolean;
	allEnvironmentsLimitation: any;
	isCreate: boolean;
	isCm: boolean;
}) =>
	yup.object({
		environmentName: validateEnvironmentName(isCm),
		sourceControlIntegrationId: validate(true, requiredAccount),
		repository: validateRepository(true),
		adoProjectName: validate(isAdoProvider, projectNameRequired),
		adoOrganization: validate(isAdoProvider, orgRequired),
		cmEnvironmentId: validate(!isCm, requriedCmEnv),
		repositoryBranch: validate(true, repoBranchRequired),
		tenantType:
			isCreate && isCm
				? yup
						.mixed<TenantType>()
						.required(t(needToContinue))
						.test(
							'all-environment-limit-validation',
							'All environment tier validation failed',
							function (value) {
								const { path, createError } = this;
								const tenantType = normalizeTenantType(value);
								const limitation =
									allEnvironmentsLimitation?.data;
								if (
									tenantType === Production &&
									limitation?.isProdLimitExceeds
								) {
									return createError({
										path,
										message: t(tenantTypeValidation3),
									});
								}

								if (
									tenantType === NonProduction &&
									limitation?.isNonProdLimitExceeds
								) {
									return createError({
										path,
										message: t(tenantTypeValidation4),
									});
								}
								return true;
							},
						)
				: notRequired(),
	});
